import BaseModel from './BaseModel';
import moment from 'moment';

class Edition extends BaseModel {
    getStatus = () => {
        const now = moment();
        const start = moment(this.start_date);
        const end = moment(this.end_date);

        if (!start.isValid() || !end.isValid())
            return 'upcoming';

        if (now.isBefore(start, 'day'))
            return 'upcoming';
        if (now.isAfter(end, 'day'))
            return 'past';
        return 'active';
    }
}

export default Edition;
